<template>
  <svg class="mobile-route-scene" viewBox="0 0 112 96" fill="none" aria-hidden="true" focusable="false">
    <g v-if="kind === 'travels'" class="travel-map">
      <path d="m10 29 30-9 30 9 31-9v52l-31 9-30-9-30 9Z" class="paper" />
      <path d="m40 20 30 9v52l-30-9Z" class="fold-shade" />
      <path d="M40 20v52m30-43v52" class="fold-line" />
      <path d="m17 39 14-4m-14 9 9-3m51 26 16-5" class="map-detail" />
      <path d="M23 62c9-18 21 5 34-10 7-8 13-1 26-8" class="route-line" />
      <circle cx="23" cy="62" r="2.6" class="route-start" />
      <path d="M83 24a8 8 0 0 0-8 8c0 6 8 13 8 13s8-7 8-13a8 8 0 0 0-8-8Z" class="accent" />
      <circle cx="83" cy="32" r="2.7" class="pin-centre" />
    </g>
    <g v-else-if="kind === 'traffic'" class="traffic-chart">
      <rect x="7" y="15" width="98" height="70" rx="4" class="paper" />
      <path d="M7 29h98" class="fold-line" />
      <circle cx="15" cy="22" r="1.2" class="window-dot" />
      <circle cx="20" cy="22" r="1.2" class="window-dot" />
      <path d="M78 22h18M16 75h80" class="map-detail" />
      <rect x="17" y="59" width="10" height="16" rx="1" class="chart-bar" />
      <rect x="33" y="51" width="10" height="24" rx="1" class="chart-bar" />
      <rect x="49" y="55" width="10" height="20" rx="1" class="chart-bar" />
      <rect x="65" y="44" width="10" height="31" rx="1" class="chart-bar" />
      <rect x="81" y="49" width="10" height="26" rx="1" class="accent chart-accent" />
      <path d="m22 51 16-9 16 5 16-12 16 5" class="chart-trend" />
      <circle cx="86" cy="40" r="2.2" class="accent" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HomeRouteMobileScene',
  props: { kind: { type: String, required: true } },
};
</script>

<style scoped>
.mobile-route-scene {
  display: block;
  width: 100%;
  height: 100%;
  color: var(--ink, #343434);
  --scene-paper: #faf9f6;
  --scene-edge: var(--route-scene-edge, rgba(90, 83, 72, .30));
  --scene-accent: rgba(var(--site-accent-rgb), .55);
}
:global(body.dark-mode .mobile-route-scene) {
  --scene-paper: #2d2c29;
}
.paper { fill: var(--scene-paper); stroke: var(--scene-edge); stroke-width: 1.2; stroke-linejoin: round; }
.fold-shade { fill: currentColor; opacity: .045; }
.fold-line { stroke: var(--scene-edge); stroke-width: 1; }
.map-detail { stroke: currentColor; stroke-width: 1; stroke-linecap: round; opacity: var(--route-scene-detail-opacity, .28); }
.route-line { stroke: var(--scene-accent); stroke-width: 1.4; stroke-linecap: round; stroke-dasharray: 2 3.5; }
.route-start { fill: var(--scene-paper); stroke: var(--scene-accent); stroke-width: 1.3; }
.accent { fill: var(--scene-accent); }
.pin-centre { fill: var(--scene-paper); }
.window-dot { fill: currentColor; opacity: var(--route-scene-detail-opacity, .28); }
.chart-bar { fill: currentColor; opacity: .16; }
.chart-accent { opacity: .7; }
.chart-trend { stroke: currentColor; stroke-width: 1.3; stroke-linecap: round; stroke-linejoin: round; opacity: .32; }
</style>
